export default {"src":"/_next/static/media/ic-vk.2b547def.svg","height":20,"width":20};